import Button from '@ixigo/iui/Button';
import { FC, useState } from 'react';
import { useConversation } from '../../contexts/conversation';
import { ActorType } from '../../enums/conversation';
import MessageBubble from '../MessageBubble';
import RadioList from '../RadioList';
import { RadioListProps } from '../RadioList/index.types';
import { InputSelectConfig } from './index.types';

const SelectInput: FC = () => {
    const { input, sendMessage } = useConversation();
    const [value, setValue] = useState<RadioListProps['data'][0]>();
    const { optionList, submitBtnLabel, required } = input!.config as InputSelectConfig;

    const onSubmit = () => {
        const messageParts = [
            {
                isPrivate: false,
                text: {
                    content: value?.label || '',
                },
            },
        ];

        sendMessage({ messageParts, input: value });
    };

    return (
        <>
            <MessageBubble actor={{ type: ActorType.BOT }} className='mr-40 ml-20'>
                <RadioList data={optionList} onChange={setValue} />
            </MessageBubble>
            <div className='mr-40 ml-20'>
                <Button
                    className='!px-20 !py-[8px]'
                    variant='outlined'
                    onClick={onSubmit}
                    disabled={required && !value}
                >
                    {submitBtnLabel || 'Submit'}
                </Button>
            </div>
        </>
    );
};

export default SelectInput;
